import React from 'react';

import { Inline, Typography } from '@crossnokaye/ux-common';

import { Tab } from '@/ux-common/components/tab/tab';
import { TabGroup } from '@/ux-common/components/tab-group/tab-group';

export type GroupBy = 'equipment' | 'setting';
const groupByItems = [
  { id: 'equipment', data: { label: 'Equipment' } },
  { id: 'setting', data: { label: 'Settings' } },
];

interface GroupByToggleProps {
  value: GroupBy;
  onChange: (value: GroupBy) => void;
}

export const GroupByToggle = ({ value, onChange }: GroupByToggleProps): React.ReactElement => {
  const handleSelectionChange = (items: Array<{ id: string }>) => {
    if (items.length > 0) {
      onChange(items[0].id as GroupBy);
    }
  };

  return (
    <Inline gap="sm" className="items-center" data-component="GroupByToggle">
      <Typography variant="body" className="text-xs uppercase tracking-wider">
        Group By:
      </Typography>
      <TabGroup
        items={groupByItems}
        selectedIds={[value]}
        onSelectionChange={handleSelectionChange}
      >
        {({ tabs }) =>
          tabs.map(({ tab, state, disabled, onToggle }) => (
            <Tab key={tab.id} data-state={state} disabled={disabled} onClick={onToggle}>
              {tab.data?.label ?? ''}
            </Tab>
          ))
        }
      </TabGroup>
    </Inline>
  );
};
